import { view, lensPath } from 'ramda'

import { isEmptyOrNil } from 'libs/empty'
import { errorCode } from 'app/constants/errorCode'

export const errorTypes = {
  login: 'login',
  register: 'register',
  default: 'default',
  emailField: 'emailField',
  changePassword: 'changePassword',
  voucher: 'voucher',
}

export const networkErrorDetails = (error) => {
  const errorDetails = view(lensPath(['response', 'data', 'details']))(error)
  return errorDetails
}

export const networkErrorToErrorType = (error) => {
  const errorCode = view(lensPath(['response', 'data', 'details', 'code']))(
    error,
  )
  const status = view(lensPath(['response', 'status']))(error)
  return statusToErrorType(status, errorCode)
}

export const statusToErrorType = (status, errorCode) => {
  return `${status}_${errorCode}`
}

export const networkErrorToMessage =
  (formatMessage) =>
  (error, type = errorTypes.default) => {
    switch (networkErrorToErrorType(error)) {
      case statusToErrorType(404, 601):
        return {
          message: formatMessage({ id: 'error.400.userNotFound' }),
        }
      case statusToErrorType(400, 602):
        switch (type) {
          case errorTypes.register:
            return {
              message: formatMessage({
                id: 'register.error.400.validationError',
              }),
            }
          default:
            return {
              message: formatMessage({ id: 'error.400.validationError' }),
            }
        }
      case statusToErrorType(400, 603):
        switch (type) {
          case errorTypes.emailField:
            return {
              message: formatMessage({
                id: 'emailField.error.400.invalidEmail',
              }),
            }
          default:
            return {
              message: formatMessage({ id: 'error.400.invalidEmail' }),
            }
        }
      case statusToErrorType(400, 604):
        return {
          message: formatMessage({
            id: 'error.400.invalidCorporationEmail',
          }),
        }
      case statusToErrorType(400, 605):
        switch (type) {
          case errorTypes.emailField:
            return null
          case errorTypes.register:
            return {
              message: formatMessage({
                id: 'register.error.400.emailExist',
              }),
            }
          default:
            return {
              message: formatMessage({ id: 'error.400.emailExist' }),
            }
        }
      case statusToErrorType(400, 606):
        return {
          message: formatMessage({ id: 'error.400.tokenExpired' }),
        }
      case statusToErrorType(400, 661):
        return {
          message: formatMessage({ id: 'error.400.phoneExist' }),
        }
      case statusToErrorType(404, 607):
        return {
          message: formatMessage({ id: 'error.400.placeNotFound' }),
        }
      case statusToErrorType(400, 608):
        return {
          message: formatMessage({ id: 'error.400.groupNameExists' }),
        }
      case statusToErrorType(400, 609):
        return {
          message: formatMessage({ id: 'error.400.groupNotExists' }),
        }
      case statusToErrorType(400, 610):
        return {
          message: formatMessage({ id: 'error.400.subgroupNameExists' }),
        }
      case statusToErrorType(400, 611):
        return {
          message: formatMessage({ id: 'error.400.subgroupNotExists' }),
        }
      case statusToErrorType(400, 612):
        return {
          message: formatMessage({ id: 'error.400.pdfCreationFailed' }),
        }
      case statusToErrorType(400, 613):
        return {
          message: formatMessage({ id: 'error.400.linkInvalid' }),
        }
      case statusToErrorType(400, 614):
        return {
          message: formatMessage({ id: 'error.400.fileTypeInvalid' }),
        }
      case statusToErrorType(400, 615):
        return {
          message: formatMessage({ id: 'error.400.fileSizeLimitExceed' }),
        }
      case statusToErrorType(400, 616):
        return {
          message: formatMessage({ id: 'error.400.subscriberNotExists' }),
        }
      case statusToErrorType(400, 617):
        return {
          message: formatMessage({ id: 'error.400.subsciberCantBeUpdated' }),
        }
      case statusToErrorType(400, 618):
        return {
          message: formatMessage({ id: 'error.400.uniqueIdExists' }),
        }
      case statusToErrorType(400, 619):
        return {
          message: formatMessage({
            id: 'error.400.notificationTranslationFailed',
          }),
        }
      case statusToErrorType(400, 620):
        return {
          message: formatMessage({ id: 'error.400.unknownLanguage' }),
        }
      case statusToErrorType(400, 621):
        return {
          message: formatMessage({ id: 'error.400.subscriberCantBeDeleted' }),
        }
      case statusToErrorType(400, 622):
        return {
          message: formatMessage({ id: 'error.400.subscriberCantBeUpdated' }),
        }
      case statusToErrorType(400, 623):
        return {
          message: formatMessage({ id: 'error.400.noSubscriberToAccept' }),
        }
      case statusToErrorType(400, 633):
        return {
          message: formatMessage({
            id: 'error.400.teamMember.updating.required.permissions',
          }),
        }
      case statusToErrorType(400, 629):
        return {
          message: formatMessage({
            id: 'error.400.editInitialNotification.notificationNotFound',
          }),
        }
      case statusToErrorType(400, 647):
        return {
          message: formatMessage({
            id: 'error.400.editInitialNotification.initialInviteNotFound',
          }),
        }
      case statusToErrorType(400, errorCode.roleNameAlreadyExists):
        return {
          message: formatMessage({
            id: 'error.400.roleNameExist',
          }),
        }
      case statusToErrorType(401, 401):
        switch (type) {
          case errorTypes.login:
            return {
              message: formatMessage({
                id: 'login.error.401',
              }),
            }
          case errorTypes.changePassword:
            return {
              message: formatMessage({
                id: 'changePassword.error.401',
              }),
            }
          default:
            return {
              message: formatMessage({ id: 'error.401' }),
            }
        }
      case statusToErrorType(403, 403):
        return {
          message: formatMessage({
            id: 'error.403.freeTierTeamMemberNotAllowed',
          }),
        }
      case statusToErrorType(404, 636):
        return {
          message: formatMessage({ id: 'error.notificationLimit' }),
        }
      case statusToErrorType(400, 675):
        return {
          message: formatMessage({
            id: 'transfer.error.cantCancel',
          }),
        }
      case statusToErrorType(400, 664):
        return {
          message: formatMessage({
            id: 'error.400.addressNotFound',
          }),
        }
      case statusToErrorType(400, 676):
        return {
          message: formatMessage({
            id: 'transfer.error.401',
          }),
        }
      case statusToErrorType(404, 802):
        return {
          message: formatMessage({
            id: 'beacons.form.error.physicalAddress.exist',
          }),
        }
      case statusToErrorType(404, 803):
        return {
          message: formatMessage({
            id: 'beacons.form.error.physicalAddress.invalid',
          }),
        }
      case statusToErrorType(400, 804):
        switch (type) {
          case errorTypes.voucher:
            return {
              message: formatMessage({
                id: 'notification.error.400.voucher.time.in.future',
              }),
            }
          default:
            return {
              message: formatMessage({
                id: 'notification.error.400.event.time.in.future',
              }),
            }
        }
      case statusToErrorType(400, 811):
        return {
          message: formatMessage({
            id: 'error.400.invalid.scheduled',
          }),
        }
      case statusToErrorType(400, 812):
        return {
          message: formatMessage({
            id: 'error.400.invalid.reminder',
          }),
        }
      case statusToErrorType(400, 813):
        return {
          message: formatMessage({
            id: 'error.400.invalid.scheduled.and.reminder',
          }),
        }
      case statusToErrorType(400, errorCode.ttsDisabled):
        return {
          message: formatMessage({
            id: 'metrics.tts.disabled.message',
          }),
        }
      default:
        return {
          message: formatMessage({ id: 'error.general' }),
        }
    }
  }

export const messageAlertError = (error, formatMessage) => {
  let errorMessage
  const errorDetails = networkErrorDetails(error)

  if (isEmptyOrNil(errorDetails)) {
    const { message } = networkErrorToMessage(formatMessage)(error)
    errorMessage = message
  } else {
    errorMessage = errorDetails.message
  }
  return errorMessage
}
